module.exports = __webpack_public_path__ + "static/media/logo-belle-event.19527e0b.svg";